// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1xq2C","radioRow":"SimpleQuestionBuilderModal_radioRow__29i-y"};